import { store } from 'Libs/redux/store';

import { fetchThematic } from './thematic/thematic.thunks';

export const initAppConfiguration = () => {
  store.dispatch(fetchThematic());
};

export const updateThematic = () => {
  store.dispatch(fetchThematic());
};
